import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, businessOnly = false }) => {
  const { user, loading, checkAuth, isPlatformAdmin, isBusiness } = useAuth();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const verifyAuth = async () => {
      // Skip if user data was passed from AuthCallback
      if (location.state?.user) {
        setIsChecking(false);
        return;
      }

      // Otherwise check authentication
      await checkAuth();
      setIsChecking(false);
    };

    verifyAuth();
    // NOTE: `checkAuth` is intentionally omitted from the dependency array.
    // It is re-created on every AuthProvider render, and it calls setUser(),
    // which re-renders the provider -> new checkAuth identity -> infinite loop
    // of GET /api/auth/me (~10 req/s) on every protected route.
  }, [location.state]);

  if (loading || isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4" />
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin routes - check for platform admin
  if (adminOnly && !isPlatformAdmin()) {
    return <Navigate to="/" replace />;
  }

  // Business routes - check for business account type
  if (businessOnly && !isBusiness()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
